import { Type } from 'class-transformer';
import { BaseDto } from './base.dto';
import { BidNotes } from './bid-notes.dto';
import { Bid } from './bid.dto';
import { Company } from './company.dto';
import { Contact } from './contact.dto';
import { InspectionField } from './inspections';
import { Order } from './order.dto';
import { Planner } from './planner.dto';
import { Project } from './project.dto';
import { SubProjectDirectory } from './sub-project-directories.dto';
import { SubProjectNote } from './sub-project-note.dto';
import { SubProjectStatus } from './sub-project-status.dto';

export class SubProject extends BaseDto {
  name?: string;
  block?: string; // גוש
  plot?: string; // חלקה
  lot?: string; // מגרש
  buildingArea?: string; // שטח המבנה
  buildingParts?: string; // חלקי המבנה
  units?: string;
  procurementNumber?: string;
  cost?: number;
  projectId?: number;
  parentSubProjectId?: number;
  relatedToSubProjectId?: number;
  relatedToOrderId?: number;
  project?: Project;
  parentSubProject?: SubProject;
  relatedToSubProject?: SubProject;
  files?: SubProjectDirectory;
  sharePoint?: SubProjectDirectory;
  orders?: Order[];
  notes?: SubProjectNote[];
  planner?: Planner;

  @Type(() => Company)
  company?: Company;
  contacts?: Contact[];
  inspectionField?: InspectionField;
  bids?: Bid[];
  status?: SubProjectStatus;
  bidNotes?: BidNotes;
  sentForConfirmationAt?: string;
  approvedAt?: string;
  version?: number;
  chosenVersion?: number;
  mainContactId?: number;
}
